import { useEffect } from "react"
import { useRouteError } from "react-router-dom"

import { logger } from "@/lib/logger"

const RELOAD_KEY = "chunk-reload-ts"
const RELOAD_COOLDOWN_MS = 10_000

function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  const msg = error.message
  return (
    msg.includes("Failed to fetch dynamically imported module") ||
    msg.includes("Importing a module script failed") ||
    msg.includes("error loading dynamically imported module") ||
    msg.includes("Loading chunk") ||
    msg.includes("Loading CSS chunk")
  )
}

export const RouteErrorBoundary = () => {
  const error = useRouteError()

  useEffect(() => {
    logger.error("RouteErrorBoundary caught error", error)

    if (isChunkLoadError(error)) {
      const now = Date.now()
      const lastReload = Number(sessionStorage.getItem(RELOAD_KEY) || "0")
      const alreadyReloaded =
        Number.isFinite(lastReload) && now - lastReload < RELOAD_COOLDOWN_MS

      if (!alreadyReloaded) {
        sessionStorage.setItem(RELOAD_KEY, String(now))
        window.location.reload()
      }
    }
  }, [error])

  return null
}
